import { render } from "./DialogueModal.vue?vue&type=template&id=21afd74c"
import script from "./DialogueModal.vue?vue&type=script&lang=js"
export * from "./DialogueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__